import {
  API_ERROR,
  UPDATE_CANCELLATION_REASON,
  FETCH_CANCELLATION_REASONS,
  DELETE_CANCELLATION_REASON,
  FETCH_USER_CANCELLATION_REPORT,
  FETCH_CANCELLATION_DISTRIBUTION_PENDING,
  FETCH_CANCELLATION_DISTRIBUTION_SUCCESS,
  FETCH_CANCELLATION_DISTRIBUTION_ERROR,
  FETCH_CANCELLATION_OVER_TIME_PENDING,
  FETCH_CANCELLATION_OVER_TIME_SUCCESS,
  FETCH_CANCELLATION_OVER_TIME_ERROR,
} from "../constants/ActionTypes";
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../constants/pagination';

const INITIAL_STATE = {
  user_cancellation_reports: [],
  pagination: {
    total: 0,
    page: DEFAULT_PAGE,
    page_size: DEFAULT_PER_PAGE,
    total_pages: 0
  },
  // Distribution chart slice — separate from the raw events list since they
  // load independently (chart on mount + period change, raw events only when
  // the operator opens the drill-down).
  distribution: {
    loading: false,
    data: null, // { period, total, objects[], comparisons? }
    error: null,
  },
  // 12-month YoY time series, independent of the period selector.
  overTime: {
    loading: false,
    data: null, // { window, buckets: [{ month, count, previous_year_count }] }
    error: null,
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_USER_CANCELLATION_REPORT:
      return {
        ...state,
        user_cancellation_reports: action.payload.data,
        pagination: {
          total: action.payload.total,
          page: action.payload.page,
          page_size: action.payload.page_size,
          total_pages: action.payload.total_pages
        }
      };
    case FETCH_CANCELLATION_DISTRIBUTION_PENDING:
      return {
        ...state,
        distribution: { ...state.distribution, loading: true, error: null },
      };
    case FETCH_CANCELLATION_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        distribution: { loading: false, data: action.payload, error: null },
      };
    case FETCH_CANCELLATION_DISTRIBUTION_ERROR:
      return {
        ...state,
        distribution: { ...state.distribution, loading: false, error: true },
      };
    case FETCH_CANCELLATION_OVER_TIME_PENDING:
      return {
        ...state,
        overTime: { ...state.overTime, loading: true, error: null },
      };
    case FETCH_CANCELLATION_OVER_TIME_SUCCESS:
      return {
        ...state,
        overTime: { loading: false, data: action.payload, error: null },
      };
    case FETCH_CANCELLATION_OVER_TIME_ERROR:
      return {
        ...state,
        overTime: { ...state.overTime, loading: false, error: true },
      };
    default:
      return state;
  }
}
